module.exports = __webpack_public_path__ + "img/5_84.c7574b7d.png";